module.exports = "/_next/static/images/connecticut-fast-channel-description-image-black-letters-f6d09b8b092dddedadaf1923da63c548.svg";